import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';

import IntroBackground from './IntroBackground.png';
import IntroBackgroundDefault from './IntroBackgroundDefault.png';
import IntroLeafs from './IntroLeafs.png';
import IntroRaptors from './IntroRaptors.png';
import biometricLock from './biometricLock.webp';

const images = {
  IntroBackground,
  IntroBackgroundDefault,
  IntroLeafs,
  IntroRaptors,
  biometricLock,
};

registerImages('auth', images);

declare global {
  interface RegisteredImages {
    auth: Record<keyof typeof images, ImageSource>;
  }
}
